import { BaseUrl } from '../base_url_enum'

export const getBaseUrl = (api: BaseUrl) => {
  switch (api) {
  case BaseUrl.Claim:
    return process.env.REACT_APP_CLAIM_API_URL ?? process.env.EXPO_PUBLIC_CLAIM_API_URL
  case BaseUrl.File:
    return ''
  case BaseUrl.Login:
    return process.env.REACT_APP_LOGIN_API_URL ?? process.env.EXPO_PUBLIC_LOGIN_API_URL
  case BaseUrl.Request:
    return process.env.REACT_APP_REQUEST_API_URL ?? process.env.EXPO_PUBLIC_REQUEST_API_URL
  case BaseUrl.Afd:
    return process.env.REACT_APP_AFD_API_URL ?? process.env.EXPO_PUBLIC_AFD_API_URL
  case BaseUrl.Content:
    return process.env.REACT_APP_CONTENT_API_URL ?? process.env.EXPO_PUBLIC_CONTENT_API_URL
  default:
    throw new Error(`Invalid BaseUrl: ${api}`)
  }
}
